import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import './css/ArticleThumbnail7.css';
import { NavLink } from 'react-router-dom';
import { getOptimXBackgroundStyle, getWebsiteImage } from '../../../../catalog/Website';
import { isValidObject, isValidString } from '../../../../catalog/Validity';
import { context } from '../../../../globalState/GlobalState';
import { getDateTimeForLastWeek, getFullDateStringFromDate, getLocalTimeFromDatabaseTime } from '../../../../catalog/DateTime';

const ArticleThumbnail7 = (props) => {
    const { article } = props;
    const { globalState } = useContext(context);

    const getImage = () => {
        if (isValidString(article.featureImage)) {
            return article.featureImage;
        } if (isValidObject(getWebsiteImage(globalState, 'articleFeatureImage'))) {
            return getWebsiteImage(globalState, 'articleFeatureImage');
        }
        return '';
    };

    const getTitle = (title) => {
        if (title.length > 40) {
            return `${title.substr(0, 40)}...`;
        }
        return title;
    };

    const getArticleTime = () => {
        if (isValidObject(article.timeOfArticle)) {
            return getLocalTimeFromDatabaseTime(article.timeOfArticle);
        }
        return getLocalTimeFromDatabaseTime(article.timeOfArticle);
    };

    return (
        <NavLink to={`/articles/${article.id}`} className="article-thumbnail7-container box-shadow-black text-black text-no-underline">
            <div className="article-thumbnail7-image-container">
                <img className="article-thumbnail7-image" src={getImage()} loading="lazy" alt={article.title ? article.title : 'Article Title'} />
                {getDateTimeForLastWeek() < getArticleTime() ? <div className="article-thumbnail7-new m-t-0 m-b-0" style={getOptimXBackgroundStyle(globalState)}>NEW</div> : null}
            </div>
            <div className="article-thumbnail7-text-container">
                <p className="article-thumbnail7-text alegreya-font-family font-weight-300 font-size-s text-left-align m-l-25px m-r-25px m-t-0 m-b-0">{getFullDateStringFromDate(getArticleTime())}</p>
                <p className="article-thumbnail7-text alegreya-font-family font-weight-700 font-size-m text-left-align m-l-25px m-r-25px m-t-0 m-b-0 title text-uppercase">{getTitle(article.title)}</p>
                <p className="article-thumbnail7-text alegreya-font-family font-weight-300 font-size-s text-left-align m-l-25px m-r-25px m-t-0 m-b-0">{isValidString(article.author) ? `By: ${article.author}` : `By: ${globalState.teamAlias}`}</p>
            </div>
        </NavLink>
    );
};

ArticleThumbnail7.propTypes = {
    article: PropTypes.object.isRequired,
};

export default memo(ArticleThumbnail7);
